import { getDomainSfx } from './utils/common';

export const API_HOST = `https://trust.yandex.${getDomainSfx()}`;

export const DESKTOP_BREAKPOINT = 768;
